import PersonalDataStep from '../components/PersonalDataStep'
import SummaryStep from '../components/driver/SummaryStep'
import { lang } from '../utils'
import SubmitStep from '../components/SubmitStep'

export const heading = 'Bewerbung als Servicekraftfahrer (m/w/d) für Hightech-Transporte'

export const steps = [
  {
    question: lang.drivers_license,
    help: 'Welchen Führerschein besitzen Sie?',
    inputs: {
      drivers_license: {
        type: 'options',
        default: [],
        multiple: true,
        options: [
          { value: 'CE' },
          { value: 'C1E' },
        ],
        rule: v8n => v8n().array().not.empty(),
        errorMessage: lang.select_all_that_apply,
      },
    },
  },
  {
    question: lang.entry_95,
    help: 'Welche gültigen Qualifizierungen besitzen Sie?',
    inputs: {
      license_and_entry_95: {
        type: 'options',
        default: [],
        multiple: true,
        options: [
          { value: 'Fahrerkarte' },
          { value: 'Module 95' },
          { value: 'Staplerschein' },
          { value: 'ADR Basis' },
        ],
        rule: v8n => v8n().array().not.empty(),
        errorMessage: 'Bitte alle zutreffenden auswählen.',
      },
    },
  },
  {
    question: lang.linquistic_proficiency,
    help: 'Welche Sprachkenntnisse bringen Sie mit?',
    inputs: {
      languages: {
        type: 'options',
        multiple: true,
        default: [],
        options: [
          { value: 'Deutsch' },
          { value: 'Englisch' },
          { value: 'Französisch' },
        ],
      },
      language_others: {
        type: 'text',
        label: 'Andere',
        rule: (v8n, { languages }) => {
          if (languages.length === 0) {
            return v8n().string().not.empty().maxLength(100)
          }
          return v8n()
        },
        errorMessage: 'Bitte alle zutreffenden auswählen.',
      },
    },
  },
  {
    question: lang.possible_start_of_work,
    help: 'Zu welchem Termin könnten Sie bei uns einsteigen?',
    inputs: {
      start_of_work: {
        type: 'date',
        default: (new Date()).toLocaleDateString('en-CA'),
        label: 'Einstiegstermin',
      },
    },
  },
  {
    question: lang.salary_expectations,
    required: false,
    inputs: {
      expected_salary: {
        type: 'text',
      },
    },
  },
  {
    component: PersonalDataStep,
    question: lang.personal_data,
    description: 'Geben Sie hier bitte Ihre persönlichen Daten an, damit wir uns mit Ihnen in Kontakt setzen können.\n' +
      '[Checkbox to request consent] DSGVO-Einwilligung* [ ] Ich willige ein, dass CDS die Daten zur\n' +
      'Kontaktaufnahme nutzen darf. Selbstverständlich werden die Daten gelöscht, sobald sie nicht mehr\n' +
      'gebraucht werden.',
    inputs: {
      street: {
        type: 'text',
        label: lang.street,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Straße an.',
      },
      house_number: {
        type: 'text',
        label: lang.house_number,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Hausnummer an.',
      },
      city: {
        type: 'text',
        label: lang.city,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Stadt an.',
      },
      postal: {
        type: 'text',
        label: lang.postal_code,
        rule: v8n => v8n().string().not.empty().numeric().length(5),
        errorMessage: 'Bitte geben Sie eine gültige Postleitzahl an.',
      },
      salutation: {
        type: 'select',
        default: 'Herr',
        label: 'Anrede',
        options: [
          { value: 'Herr' },
          { value: 'Frau' },
          { value: 'Divers' },
        ],
      },
      first_name: {
        type: 'text',
        label: lang.first_name,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie einen gültigen Vornamen an.',
      },
      last_name: {
        type: 'text',
        label: lang.last_name,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie einen gültigen Nachnamen an.',
      },
      telephone_number: {
        type: 'tel',
        label: lang.telephone,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Telefonnummer an.',
      },
      email: {
        type: 'email',
        label: lang.email,
        rule: v8n => v8n().string().not.empty().maxLength(100).pattern(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
        ),
        errorMessage: `Bitte geben Sie eine gültige ${lang.email} an.`,
      },
      email_confirmation: {
        type: 'email',
        label: 'E-Mail wiederholen',
        rule: (v8n, form) => v8n().string().equal(form.email),
        errorMessage: `Bitte stellen Sie sicher, dass die E-Mail übereinstimmt.`,
      },
    },
  },
  {
    question: lang.additional_information,
    help: 'Wollen Sie uns darüber hinaus noch etwas mitteilen? Außerdem können Sie optional Dokumente\n' +
      'wie z.B. einen Lebenslauf hochladen.',
    required: false,
    inputs: {
      additional_information: {
        type: 'textarea',
        rule: v8n => v8n().
          optional(v8n().string().not.empty().maxLength(200), true),
        errorMessage: 'Bitte geben Sie eine gültige Eingabe ein.',
      },
      file_upload: {
        type: 'file',
        label: 'File upload',
      },
    },
  },
  {
    component: SummaryStep,
    question: 'Ihre Angaben (Korrekturen Sind Möglich)',
    inputs: {},
  },
  {
    component: SubmitStep,
    question: 'Absenden der Bewerbung',
    inputs: {},
  },
]
